import NextImage, { ImageLoaderProps, ImageProps } from 'next/image'

export const cfLoader = ({ src, width, quality }: Omit<ImageLoaderProps, 'config'>) => {
  const params = `width=${width},quality=${quality || 75},format=auto`
  let origin
  if (typeof window != 'undefined') {
    origin = window.location.origin
  } else {
    origin = 'https://staging.edgeseo.pro'
  }
  if (origin.includes('localhost')) {
    return `${src}?${params}`
  } else {
    return `${origin}/cdn-cgi/image/${params}/${origin}${src}`
  }
}

const Image = ({ caption, ...rest }: { caption?: string } & ImageProps) => (
  <figure>
    <NextImage loader={cfLoader} {...rest} />
    {caption && <figcaption>{caption}</figcaption>}
  </figure>
)

export default Image
